import ContactForm from "./ContactForm";
import GoogleMaps from "./GoogleMaps";
import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';
import { useRouter } from 'next/router';
import HeadingServices from "../services/HeadingServices";

export default function Contact(props) {


    const router = useRouter();
    let language =  router.locale === "tr" ? "Turkish" : "English";

    return (
        <GoogleReCaptchaProvider
            language={language}
            reCaptchaKey={process.env.reCAPTCHA_site_key}
            useRecaptchaNet
            scriptProps={{ async: true, defer: true, appendTo: 'body' }}
        >
            <HeadingServices lowerTitle={props.data.title}/>
            <div className="container my-lg-3 my-2">
                <div className="row pt-2 pt-md-3 mb-4">
                    <ContactForm
                        datas={props.data}
                        lacale={router.locale}
                    />
                    <div className="row mx-0 w-100" 
                        style={{justifyContent:"space-between"}}>
                        <div className="col-md-6 col-lg-6">
                            <GoogleMaps
                                company={props.data.company}
                                contactAdress={props.data.contactAdress}
                                contactNumber={props.data.contactNumber}
                                lat={props.data.coordinatesLat}
                                lng={props.data.coordinatesLong}
                                src={'/american.png'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </GoogleReCaptchaProvider>
    )
}
